module.exports = __webpack_public_path__ + "static/no-path-53ce41dda23bf177994e12e5ab5b89da.svg";